
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion.tsx";

const FAQSection = () => {
  const faqs = [
    // --- Fragen der Angehoerigen zuerst: sie richten ein und bezahlen ---
    {
      question: "Muss meine Mutter ein Smartphone haben?",
      answer:
        "Nein. Ein ganz normales Handy genügt, das SMS empfangen kann – auch ein Tastenhandy. Es muss nichts installiert, eingerichtet oder gelernt werden. Wer WhatsApp nutzt, kann die Nachricht auch dort bekommen.",
    },
    {
      question: "Was, wenn sie die Nachricht mal übersieht?",
      answer:
        "Dann bekommen Sie eine Meldung – vier Stunden nach der Nachricht am Morgen. Das ist der Sinn des Dienstes: Sie müssen nicht selbst nachhalten. In den allermeisten Fällen ist es ein Fehlalarm und ein kurzer Anruf klärt es. Genau dieser Anruf ist der, den Sie sonst jeden Tag machen müssten.",
    },
    {
      question: "Merkt meine Mutter, dass ich das eingerichtet habe?",
      answer:
        "Ja, und das ist Absicht. Bevor die erste tägliche Nachricht kommt, erhält sie von uns eine Begrüssung, in der Ihr Name steht und was Sie eingerichtet haben. Sie kann jederzeit mit STOPP antworten, dann stellen wir die Nachrichten sofort ein und informieren Sie. Wir schreiben niemanden heimlich an – bei der Anmeldung bestätigen Sie, dass Sie sie gefragt haben.",
    },
    {
      question: "Was kostet es und wer zahlt?",
      answer:
        "9.90 CHF bzw. 9.90 € pro Monat, bezahlt von dem Konto, das den Dienst einrichtet – also in der Regel von Ihnen, nicht von Ihrer Mutter. Sind Sie in den ersten 7 Tagen nicht überzeugt, erstatten wir den Monatsbeitrag. Jederzeit kündbar.",
    },

    // --- Ablauf ---------------------------------------------------------
    {
      question: "Wie funktioniert die Nachricht genau?",
      answer:
        "Jeden Morgen um 8 Uhr geht eine kurze Nachricht per SMS oder WhatsApp raus: eine freundliche Frage, wie es geht. Ein Wort als Antwort genügt – 'Gut' reicht völlig.",
    },
    {
      question: "Was passiert, wenn keine Antwort kommt?",
      answer:
        "Vier Stunden nach der Nachricht, also um 12 Uhr, benachrichtigen wir die hinterlegte Kontaktperson – per SMS oder WhatsApp. Kommt die Antwort rechtzeitig, passiert nichts. Keine Nachricht von uns bedeutet: alles in Ordnung.",
    },
    {
      question: "Kann ich die Uhrzeit selbst bestimmen?",
      answer:
        "Noch nicht. Die Nachricht geht derzeit für alle um 8 Uhr raus, die Benachrichtigung der Kontaktperson um 12 Uhr. Frei wählbare Zeiten sind geplant.",
    },
    {
      question: "Kann man den Dienst pausieren?",
      answer:
        "Die Person, die die Nachrichten erhält, kann jederzeit mit STOPP antworten. Dann werden die Nachrichten sofort eingestellt und das Konto informiert. Für eine Pause und die spätere Wiederaufnahme schreiben Sie uns kurz – eine Pausenfunktion im Konto bauen wir gerade.",
    },
    {
      question: "Muss man eine App installieren?",
      answer:
        "Nein. Die Nachricht kommt per WhatsApp oder SMS auf das Handy, das ohnehin schon da ist – keine App, kein Login, kein neues Gerät.",
    },

    // --- Vertrauen ------------------------------------------------------
    {
      question: "Werden die Antworten gelesen?",
      answer:
        "Nein. Wir prüfen nur, ob überhaupt eine Antwort eingegangen ist – ein Lebenszeichen. Der Inhalt wird nicht ausgewertet und nicht weitergegeben. Bitte trotzdem keine sensiblen Angaben hineinschreiben.",
    },
    {
      question: "Ist das ein Notruf?",
      answer:
        "Nein, und das ist wichtig. esgehtmirgut ersetzt keinen Notruf und keinen Pflegedienst. Wir bemerken, wenn sich jemand einen Tag lang nicht meldet – nicht mehr, aber auch nicht weniger. In einem Notfall wählen Sie 144.",
    },
    {
      question: "Für wen eignet sich esgehtmirgut.ch?",
      answer:
        "Für Menschen, die alleine leben – unabhängig vom Alter. Und für Angehörige, die nicht jeden Tag anrufen möchten und trotzdem wissen wollen, dass alles in Ordnung ist.",
    },
  ];
  
  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16">
          Häufige Fragen
        </h2>
        
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white border border-gray-200 rounded-lg px-6"
            >
              <AccordionTrigger className="text-left text-lg font-semibold hover:no-underline py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 pb-6 text-base leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
